module.exports = __webpack_public_path__ + "static/media/EmpireStateBuilding.ee291595.png";